import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectAllP2pSettings } from "../../redux/slices/p2pSettingsSlice";
import EmployerMatchingControl from "./EmployerMatchingControl";

const ConnectedEmployerMatchingControl = ({ controlId }) => {
    const {
        ENUMS: { MatchingType },
    } = constants;
    const { matchingType } = useSelector(selectAllP2pSettings);

    const isManualMatch = matchingType === MatchingType.MANUAL;

    return (
        <EmployerMatchingControl
            controlId={controlId}
            isManualMatch={isManualMatch}
        />
    );
};

export default ConnectedEmployerMatchingControl;
